import type { TransactionsTypes } from '@modules';
import { LoadersType } from '@modules/builders';

import { asyncActions } from './actions';

export type TransactionsStateType = {
  loaders: LoadersType<typeof asyncActions>;
  referral: {
    data?: TransactionsTypes.GetReferralResponse;
    list: TransactionsTypes.GetReferralTransactionsResponse[];
  };
  list: TransactionsTypes.TSortTransactions;
  total?: number;
};

export const initialState: TransactionsStateType = {
  loaders: {},
  referral: {
    list: [],
  },
  list: {},
  total: 0,
};

export default initialState;
